import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const SESSION_KEY = "dd_customer";
const SESSION_MS = 12 * 60 * 60 * 1000;

export const getCustomerSession = () => {
  try {
    const s = JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
    if (!s || Date.now() > s.expires_at) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    return s;
  } catch {
    return null;
  }
};

export const saveCustomerSession = (token, user) =>
  localStorage.setItem(SESSION_KEY, JSON.stringify({ token, ...user, expires_at: Date.now() + SESSION_MS }));

export const clearCustomerSession = () => localStorage.removeItem(SESSION_KEY);

export const getDeviceId = () => getCustomerSession()?.id || crypto.randomUUID();

export const api = axios.create({ baseURL: API_BASE });
api.interceptors.request.use((config) => {
  const s = getCustomerSession();
  if (s?.token) config.headers.Authorization = `Bearer ${s.token}`;
  return config;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && getCustomerSession()) {
      clearCustomerSession();
      window.dispatchEvent(new CustomEvent("dd:customer-unauth"));
    }
    return Promise.reject(err);
  }
);

export const STAFF_KEYS = { owner: "dd_owner_token", admin: "dd_admin_token", dj: "dd_dj_token" };

const makeStaffApi = (role) => {
  const inst = axios.create({ baseURL: API_BASE });
  inst.interceptors.request.use((config) => {
    const token = localStorage.getItem(STAFF_KEYS[role]);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  inst.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 401) {
        localStorage.removeItem(STAFF_KEYS[role]);
        window.dispatchEvent(new CustomEvent(`dd:${role}-unauth`));
      }
      return Promise.reject(err);
    }
  );
  return inst;
};

export const ownerApi = makeStaffApi("owner");
export const adminApi = makeStaffApi("admin");
export const djApi = makeStaffApi("dj");
export const staffApis = { owner: ownerApi, admin: adminApi, dj: djApi };

export const uploadImage = async (file, client = api, path = "/upload") => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await client.post(path, form, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
};

export const buildFileUrl = (urlOrPath) => {
  if (!urlOrPath) return null;
  if (urlOrPath.startsWith("http")) return urlOrPath;
  return `${BACKEND_URL}${urlOrPath.startsWith("/api") ? "" : "/api"}${urlOrPath.startsWith("/") ? "" : "/"}${urlOrPath}`;
};

export const errMsg = (e, fallback = "Something went wrong") => e?.response?.data?.detail || fallback;
